const stmErrCodes = require('./studiemeister');
const hogesErrCodes = require('./hoges');
const sharedErrCodes = require('./shared');

/**
 * HE-LEARNING ERROR NAMING CONVENTION
 * E-{Abbreviature of the app}-{Abbreviature of service name}-{Abbreviature of error description}
 * Example: E-STM-CON-XXXXX
 */
module.exports = {
  stmErrCodes,
  hogesErrCodes,
  sharedErrCodes,
};
